module.exports = __webpack_public_path__ + "assets/resstar2-0at2x.95d76f377970aaa60d8c77b6c40c2509.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/stars/resstar2-0at2x.png
// module id = 854
// module chunks = 0